import { getWindowSize, missingWidget } from '../utils/helpers';
import { updateLinksAttributes } from '../utils/handleAttributes';

const breakpointMobile = 815;

// Function Helpers
function buildCardButton(URL, Title, isDesktop) {
  if (!URL) return '';

  if (isDesktop) {
    return `<a href="${URL}" class="button alternative-btn" ${updateLinksAttributes(URL, Title)}>More ></a>`;
  }

  return '<span class="button alternative-btn">More ></span>';
}

function isMobileView() {
  return !getWindowSize(breakpointMobile);
}

export default function cardWidget(widgetNameVariable, widgetOptsVariable, maxItems) {
  const widgetName = widgetNameVariable;
  const widgetOpts = widgetOptsVariable === undefined ? null : widgetOptsVariable;

  const $widget = $(`#${widgetName}`);

  if (!widgetOpts) {
    $widget.remove();
    missingWidget(widgetName);
    return;
  }

  let isCardLinked = isMobileView();

  function init() {
    return saffire.widgets.cardWidget($widget, {
      currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
      scriptPath: widgetOpts.scriptPath,
      link: getWindowSize(breakpointMobile) ? [''] : ['all'],
      hasImages: true,
      lazyLoadImages: true,
      imageIsBackground: true,
      textOverImage: true,
      maxItemsVisible: maxItems,
      itemsPerPanel: 6,
      showDescription: false,
      moreButton: false,
      buyNowButton: false,
      cardWidgetLoaded: function (data, _owl, hasData) {
        if (hasData) {
          createGallery(data.items);
        }
      },
    });
  }

  init();

  $(globalThis).on('resize', function () {
    const next = isMobileView();
    if (next === isCardLinked || !$widget.find('.card-widget-item').length) return;
    isCardLinked = next;
    $widget.empty();
    init();
  });

  function createGallery(widgetData) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();
    if (widgetData.length < 2) {
      $widget.addClass('single-card');
    }

    const isDesktop = getWindowSize(breakpointMobile);

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $cardItem = $(this);
      if (URL == null || URL == undefined || (URL == '' && !$cardItem.hasClass('void-link'))) {
        $cardItem.addClass('void-link');
      }

      const button = buildCardButton(URL, Title, isDesktop);

      $cardItem.find('.image-container').append(`
          <div class="card-content">
            <h3 class="widget-title">${Title}</h3>
            <div class="hover-content">
            ${button}
            </div>
          </div>`);

      if (!isDesktop) {
        updateLinksAttributes(URL, Title, $cardItem);
      }
    });
  }
}
